import { useParams } from "react-router-dom";
import { projects } from "../assets/config/config"; // Import projects data
import styles from "../assets/scss/pagesScss/projectDetails.module.scss"; // Import SCSS
import Hearder from "../component/common/header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import ClientCarousel from "../component/ourClient";

const ProjectDetail = () => {
  const { id } = useParams();
  const project = projects.find((p) => p.id === parseInt(id));

  if (!project) {
    return <h2>Project not found</h2>;
  }

  return (
    <>
      <Hearder title="Project" breadcrumb={project.title} />
      <section className={styles.project}>
        <div className="container">
          <div className={styles.project_detail}>
            <div className={styles.project_header}>
              <span className={styles.date}>
                <FontAwesomeIcon icon={faCalendarAlt} />{" "}
                {dayjs(project.date).format("MMM DD, YYYY")}
              </span> 
              <h1 className={styles.project_title}>{project.title}</h1>
              <p className={styles.project_description}>{project.description}</p>
            </div>

            <div className={styles.project_thumbnail}>
              <img src={project.thumbnail} alt={project.title} />
            </div>

            <div className={styles.project_gallery}>
              {project.images.map((img, index) => (
                <div key={index} className={styles.gallery_item}>
                  <img src={img} alt={`Project Image ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <ClientCarousel />
    </>
  );
};

export default ProjectDetail;
